import React, { useState, useEffect } from "react";
import axios from "axios";
import Window from "../../../../elements/window";
import Loader from "../../../../../settings/loader";
import Slide1 from "./slides/slide1";
import { useAppContext } from "../../../../../../AppContext";

function AuditSummary({ filter }) {
  const { user, chimeraserv } = useAppContext();
  const props = { user, chimeraserv, filter };
  const [data, setData] = useState({
    audit: {
      data: [],
      state: false,
    },
    state: false,
  });
  const [load, setLoad] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      if (props.user.data) {
        const headers = {
          Authorization: props.user.data.usrKey,
          "Content-Type": "application/json",
          Accept: "application/json",
        };

        let { base64 } = props.filter;
        base64 = JSON.parse(atob(base64));
        delete base64.revCent;
        base64 = window.btoa(JSON.stringify(base64));

        try {
          const response = await axios.post(
            props.chimeraserv.urlGet + "/audit/set/0/",
            { id: base64 },
            { headers }
          );
          setData((prev) => ({
            ...prev,
            audit: {
              data: response.data,
              state: true,
            },
          }));
        } catch (error) {
          setData((prev) => ({
            ...prev,
            audit: {
              data: [],
              state: true,
            },
          }));
        }
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, [props.user.data, props.chimeraserv.urlGet, props.filter]);

  useEffect(() => {
    if (data.audit.state && !load) {
      setData((prev) => ({
        ...prev,
        state: true,
      }));
      setLoad(1);
    }
    // eslint-disable-next-
  }, [props.user.data, props.chimeraserv.urlGet, props.filter]);

  useEffect(() => {
    if (data.audit.state && !load) {
      setData((prev) => ({
        ...prev,
        state: true,
      }));
      setLoad(1);
    }
    // eslint-disable-next-line
  }, [data.audit.state, load]);
  return (
    <section>
      {!load ? (
        <Loader />
      ) : (
        <div>
          <Window
            user={props.user}
            chimeraserv={props.chimeraserv}
            title={"Audits"}
          >
            <Slide1
              // {...props}
              user={props.user}
              chimeraserv={props.chimeraserv}
              filter={props.filter}
              data={data}
            />
          </Window>
        </div>
      )}
    </section>
  );
}
export default AuditSummary;
